/**
 * Pure formatting helpers used by the Reports page and its charts.
 *
 * Extracted from Reports.tsx during the Maintainability Sprint 2026-04-19
 * (Task 1.2). Behavior preserved byte-for-byte.
 */

/** Format an amount in FCFA using fr-SN locale, with ` FCFA` suffix. */
export function formatFcfa(amount: number): string {
  return `${new Intl.NumberFormat("fr-SN").format(amount)} FCFA`;
}

/** Format a date string as DD/MM/YYYY via fr-SN locale. */
export function formatDate(d: string): string {
  return new Date(d).toLocaleDateString("fr-SN");
}

/** Format a date string as zero-padded DD/MM (no year) — used on chart axes. */
export function formatShortDate(d: string): string {
  const date = new Date(d);
  return `${String(date.getDate()).padStart(2, "0")}/${String(
    date.getMonth() + 1,
  ).padStart(2, "0")}`;
}
